import { combineReducers, type Reducer } from 'redux';
import {
  gisServices,
  keywordsSetsReducer,
  keywordsTiersReducer,
} from '@rsos/reduxDataStore';
import incidents from '@rsos/reduxDataStore/src/features/alerts/incidentsSlice';
import alertsRouting from '@rsos/reduxDataStore/src/features/alertsRouting/alertsRoutingSlice';
import psaps from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import peerAgencies from '@rsos/reduxDataStore/src/features/peerAgencies/peerAgenciesSlice';
import { rsosApi } from '@rsos/reduxDataStore/src/features/rsosApi';
import { sinatra } from '@rsos/sinatra';
import appAccess from '../sections/access_management/reducers/appReducer';
import appAlertsRouting from '../sections/alerts_routing/app/appSlice';
import communication from '../sections/communication/app/appSlice';
import mapLayerSettings from '../sections/datasource/state/MapLayerSettingsSlice';
import { appReducer as appDataSource } from '../sections/datasource/state/appSlice';
import { spatialLayers } from '../sections/datasource/state/spatialLayersSlice';
import adeleReducer from '../sections/integration_management/reducers/adeleReducer';
import appIntegration from '../sections/integration_management/reducers/appReducer';
import integrationsReducer from '../sections/integration_management/reducers/integrationsReducer';
import { initializationReducer } from '../sections/keyword/state/initialization';
import landingZones from '../sections/landing_zones/state/appSlice';
import notifications from '../sections/notifications/app/appSlice';
import appPeerAgencies from '../sections/peer_agencies/app/appSlice';
import appPsap from '../sections/psap_management/reducers/appReducer';
import issuesReducer from '../sections/psap_management/reducers/issuesReducer';
import responders from '../sections/responders/app/appSlice';
import appSettings from '../sections/settings/app/appSlice';

// These legacy JS reducers (from access/integration/psap) have loosely and
// inconsistently typed state; widen them to Reducer so their inferred union
// types don't break configureStore's strict reducer typing.
const adele: Reducer = adeleReducer;
const integrations: Reducer = integrationsReducer;
const issues: Reducer = issuesReducer;

// Each admin section keeps its own init/state slices under unique keys; the
// shared slices (sinatra, psaps, incidents, keywordTiers/Sets, gisServices,
// rsosApi) are registered once here instead of once per former microfrontend.
const rootReducer = combineReducers({
  communication,
  notifications,
  appSettings,
  appDataSource,
  initialization: initializationReducer,
  sinatra,
  psaps,
  incidents,
  keywordTiers: keywordsTiersReducer,
  keywordSets: keywordsSetsReducer,
  gisServices,
  spatialLayers,
  mapLayerSettings,
  appAlertsRouting,
  alertsRouting,
  responders,
  appPeerAgencies,
  peerAgencies,
  landingZones,
  appAccess,
  appIntegration,
  integrations,
  adele,
  appPsap,
  issues,
  [rsosApi.reducerPath]: rsosApi.reducer,
});

export default rootReducer;

export type AdminState = ReturnType<typeof rootReducer>;
